import { render, staticRenderFns } from "./TemplateSettingEdit.vue?vue&type=template&id=0412e461&scoped=true"
import script from "./TemplateSettingEdit.vue?vue&type=script&lang=js"
export * from "./TemplateSettingEdit.vue?vue&type=script&lang=js"
import style0 from "./TemplateSettingEdit.vue?vue&type=style&index=0&id=0412e461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0412e461",
  null
  
)

export default component.exports